export const splitStringByNewLine = (text: string) => text.split('\n');
